module.exports = ["做最真实的自己","做个好人，简单可依赖","热爱生活，让日常，不寻常","愿你被世界温柔相待","人生是场修行，见天地，见自己","包容并静默，不问不怨，不哀伤","不乱于心，不困于情，不念过往，不畏将来","希望你对过往一切情深义重但从不回头","真正的勇敢，不是没有弱点，而是带着恐惧前行","你简单，这世界就简单","一辈子做对与做错的事，会不会刚好一样多","我们都要尽量靠近光亮，让心情温暖","任时光匆匆流去，我只在乎你","把美好事物纯真走完，沿途你不枉为少年","不负美食不负心","食物有很强的治愈力量","如果你不出去走走，你会以为这就是世界","不要走得太快，灵魂都跟不上了","大声地笑出声来，就不再害怕了","到不了的地方叫做远方，回不去的世界叫做家乡","我们把世界看错了，反说它欺骗我们","群星不怕显得像萤火那样","若能避开猛烈的狂喜，自然不会有悲矜来袭","雨窗和泪摇湘管，意长笺短","东风不管琵琶怨，落花吹遍","人面不知何处，绿波依旧东流","We are 伐木累"]


//////////////////
// WEBPACK FOOTER
// ./src/data/blessing.json
// module id = ENLZ
// module chunks = 32